const CLICK_REPORT_PLATFORM = 'web'
const ANON_ID_STORAGE_KEY = 'growth-click-report-anon-id'
const POPUP_DEVICE_ID_STORAGE_KEY = 'growth-popup-device-id'

const hasValue = value => value !== null && value !== undefined && value !== ''

export const getGrowthPopupDeviceId = () => {
  let deviceId = localStorage.getItem(POPUP_DEVICE_ID_STORAGE_KEY)

  if (!deviceId) {
    deviceId = window.crypto?.randomUUID?.() || randomString()
    localStorage.setItem(POPUP_DEVICE_ID_STORAGE_KEY, deviceId)
  }

  return deviceId
}

const getGuestAnonId = (anonId) => {
  const userStore = useUserStore()

  if (userStore.token) {
    return undefined
  }

  if (hasValue(anonId)) {
    return anonId
  }

  let guestAnonId = localStorage.getItem(ANON_ID_STORAGE_KEY)

  if (!guestAnonId) {
    guestAnonId = window.crypto?.randomUUID?.() || randomString()
    localStorage.setItem(ANON_ID_STORAGE_KEY, guestAnonId)
  }

  return guestAnonId
}

export const reportGrowthBannerClick = async ({ bizType = 'banner', itemId, anonId } = {}) => {
  if (!hasValue(itemId)) {
    return
  }

  const reportAnonId = getGuestAnonId(anonId)
  const body = {
    bizType,
    itemId,
    platform: CLICK_REPORT_PLATFORM,
    ...(hasValue(reportAnonId) ? { anonId: reportAnonId } : {}),
  }

  try {
    const { execute } = userApi.growthClickReport(body)
    await execute()
  } catch (error) {
    console.log('growth click report failed', error)
  }
}

export const reportGrowthPopupClick = async ({ itemId } = {}) => {
  if (!hasValue(itemId)) {
    return
  }

  try {
    const { execute } = userApi.growthClickReport({
      bizType: 'popup',
      itemId,
      platform: CLICK_REPORT_PLATFORM,
      deviceId: getGrowthPopupDeviceId(),
      clickTime: Date.now(),
    })
    await execute()
  } catch (error) {
    console.log('growth popup click report failed', error)
  }
}
